module.exports = __webpack_public_path__ + "static/Handball-85f92665cb9dc555c31b1ee36b14a791.mp4";